
export enum ErrorType {
  API = 'API',
  VALIDATION = 'VALIDATION',
  NETWORK = 'NETWORK',
  AUTH = 'AUTH',
  GENERIC = 'GENERIC'
}

export enum ErrorSeverity {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

export interface StandardError {
  type: ErrorType;
  severity: ErrorSeverity;
  message: string;
  code?: string | number;
  details?: unknown;
  timestamp: Date;
  context?: {
    component?: string;
    action?: string;
    userId?: string;
    [key: string]: unknown;
  };
}

export interface ErrorHandlerOptions {
  showToast?: boolean;
  logError?: boolean;
  severity?: ErrorSeverity;
  context?: StandardError['context'];
}
